/**
 * @flow
 * @relayHash 89edd6b5a5a647533aba8ea1fd6526b5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ConfigurableBlockDeleteInput = {
  id: string,
  clientMutationId?: ?string,
};
export type ConfigurableBlockDeleteMutationVariables = {|
  input: ConfigurableBlockDeleteInput
|};
export type ConfigurableBlockDeleteMutationResponse = {|
  +ConfigurableBlockDelete: ?{|
    +error: ?string
  |}
|};
export type ConfigurableBlockDeleteMutation = {|
  variables: ConfigurableBlockDeleteMutationVariables,
  response: ConfigurableBlockDeleteMutationResponse,
|};
*/


/*
mutation ConfigurableBlockDeleteMutation(
  $input: ConfigurableBlockDeleteInput!
) {
  ConfigurableBlockDelete(input: $input) {
    error
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ConfigurableBlockDeleteInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "ConfigurableBlockDelete",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "ConfigurableBlockDeleteInput!"
      }
    ],
    "concreteType": "ConfigurableBlockDeletePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "error",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "ConfigurableBlockDeleteMutation",
  "id": null,
  "text": "mutation ConfigurableBlockDeleteMutation(\n  $input: ConfigurableBlockDeleteInput!\n) {\n  ConfigurableBlockDelete(input: $input) {\n    error\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ConfigurableBlockDeleteMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "ConfigurableBlockDeleteMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '019280861938ac8fed11063913d3dd02';
module.exports = node;



// WEBPACK FOOTER //
// src/components/configurable-blocks/mutations/__generated__/ConfigurableBlockDeleteMutation.graphql.js